import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  loginImage: {
    display: "flex",
    justifyContent: "center",
  },
  backgroundImg: {
    background: `linear-gradient(0deg, rgba(48, 48, 56, 0.7), rgba(48, 48, 56, 0.7)), url("images/webRating/bg.jpg")`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  checkimage: {
    width: "12vw",
  },
  thankyouText: {
    fontFamily: "Inter",
    fontSize: "2vw",
    fontWeight: 400,
    lineHeight: "2.5vw",
    color: "white",
    textAlign: "center",
    width: "100%",
    margin: "auto",
    marginTop: "10%",
  },
  container: {
    margin: "auto",
    textAlign: "center",
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      padding: "0 9px",
    },
  },
  copyButton: {
    backgroundColor: "transparent !important",
    padding: "0px 0px 0px 2px !important",
    lineHeight: "0",
    height: "20px !important",
  },
  copyText: {
    fontFamily: "Inter",
    fontSize: "1vw",
    fontWeight: 400,
    lineHeight: "1.5vw",
    color: "white",
    textAlign: "center",
    width: "60%",
    margin: "auto",
    marginTop: "1%",
  },
  copyTextMobile: {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 400,
    lineHeight: "11px",
    color: "white",
    textAlign: "center",
    width: "60%",
    margin: "auto",
    marginTop: "1%",
  },
  thankyouMobileText: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: 1.5,
    color: "white",
    textAlign: "center",
    width: "100%",
    maxWidth: "100%",
    margin: "auto",
    marginTop: "10%",
    padding: "0 16px",
    boxSizing: "border-box",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    "& p": {
      margin: 0,
      wordBreak: "break-word",
      overflowWrap: "break-word",
    },
  },
  googleText: {
    fontFamily: "Inter",
    fontSize: "1.5rem",
    fontWeight: 400,
    color: "white",
    textAlign: "center",
    marginTop: "3rem",
  },
  googleMobileText: {
    fontFamily: "Inter",
    fontSize: "0.8rem",
    fontWeight: 400,
    color: "white",
    textAlign: "center",
    marginTop: "1rem",
  },
  googleReviewContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  googleReviewButton: {
    userSelect: "none",
    fontSize: "1rem",
    fontWeight: 500,
    textDecoration: "none",
    width: "max-content",
    marginTop: "1rem",
    border: "1px solid gainsboro",
    borderRadius: "40px",
    padding: "0.20rem 1.5rem 0.45rem 1rem",
    cursor: "pointer",
    backgroundColor: "white",
    color: "black",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "whitesmoke",
      color: "black",
    },
    "&:focus": {
      backgroundColor: "whitesmoke",
      color: "black",
    },
    "&:active": {
      backgroundColor: "gainsboro",
      color: "black",
    },
  },
  termAndCondition: {
    position: "fixed",
    bottom: "0",
    right: "0",
    margin: "7px auto",
    width: "100%",
    color: "white",
    "&:hover": {
      color: "white",
    },
  },
}));
